import { render, staticRenderFns } from "./MenuConfigWindow.vue?vue&type=template&id=27a590a8&scoped=true"
import script from "./MenuConfigWindow.vue?vue&type=script&lang=js"
export * from "./MenuConfigWindow.vue?vue&type=script&lang=js"
import style0 from "./MenuConfigWindow.vue?vue&type=style&index=0&id=27a590a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a590a8",
  null
  
)

export default component.exports